import { css } from 'styled-components'
import {
  CommonBodyBackgroundMobileStyles,
  CommonBodyBackgroundUiStylesInterface,
} from 'common/components/entities/body/ui/body-background-ui'

export const BackgroundUi = () => css<CommonBodyBackgroundUiStylesInterface>`
  ${p =>
    p.theme.isEditorMobileMode &&
    css<CommonBodyBackgroundUiStylesInterface>`
      max-width: 350px;
      ${p?.mobileBackground?.backgroundAttachment === 'fixed' &&
      css`
        position: absolute;
      `}
      ${CommonBodyBackgroundMobileStyles}
    `}
`
